import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import ConfirmationModal from '../../components/molecules/ConfirmationModal';
const ConfirmationContext = createContext(undefined);
export const WithConfirmation = ({ children }) => {
    const [confirmationState, setConfirmationState] = useState(null);
    const showConfirmation = (options) => {
        return new Promise((resolve) => {
            setConfirmationState({
                isOpen: true,
                options,
                resolve,
            });
        });
    };
    const handleSubmit = () => {
        if (confirmationState) {
            confirmationState.resolve(true);
            setConfirmationState(null);
        }
    };
    const handleCancel = () => {
        if (confirmationState) {
            confirmationState.resolve(false);
            setConfirmationState(null);
        }
    };
    const handleClose = () => {
        if (confirmationState) {
            confirmationState.resolve(false);
            setConfirmationState(null);
        }
    };
    return (_jsxs(ConfirmationContext.Provider, { value: { showConfirmation }, children: [children, confirmationState && (_jsx(ConfirmationModal, { isOpen: confirmationState.isOpen, onSubmit: handleSubmit, onCancel: confirmationState.options?.disableCancel ? undefined : handleCancel, onClose: handleClose, title: confirmationState.options.title, body: confirmationState.options.body, submitText: confirmationState.options.submitText, cancelText: confirmationState.options.cancelText, hideCloseButton: confirmationState.options.disableClose, ...confirmationState.options }))] }));
};
export const useConfirmation = () => {
    const context = useContext(ConfirmationContext);
    if (!context) {
        throw new Error('useConfirmation must be used within a WithConfirmation provider');
    }
    return context.showConfirmation;
};
//# sourceMappingURL=index.js.map